import { render, staticRenderFns } from "./gjsz.vue?vue&type=template&id=2a2352cd&scoped=true&"
import script from "./gjsz.vue?vue&type=script&lang=js&"
export * from "./gjsz.vue?vue&type=script&lang=js&"
import style0 from "./gjsz.vue?vue&type=style&index=0&id=2a2352cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2352cd",
  null
  
)

export default component.exports